module.exports = __webpack_public_path__ + "statics/img/bg.5c8c962b.png";